export default __webpack_public_path__ + "static/media/plantsAndSky.d1897ee9.jpg";